/** Цена инструмента: как у брокера, до 4 знаков после запятой. */
export function formatPrice(value) {
    return value.toFixed(4);
}
/** Нормализация цены перед отправкой ордера. */
export function roundPrice(value) {
    return Number(value.toFixed(4));
}
/** Деньги / PnL / notional — 2 знака. */
export function formatMoney(value) {
    return value.toFixed(2);
}
